import { render, staticRenderFns } from "./PrisonTabName.vue?vue&type=template&id=0cc4e8f1&"
import script from "./PrisonTabName.vue?vue&type=script&lang=js&"
export * from "./PrisonTabName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports